document.addEventListener('teeinblue-event-after-cart-added', () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
      fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then(res => res.json())
      .then(res => drawer.renderContents({sections: res}));
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
  }    
});


document.addEventListener('DOMContentLoaded', () => {
  const quantityUpsellEls = document.querySelectorAll('.quantity-upsell [data-quantity]');

  quantityUpsellEls.forEach((quantityUpsell) => {
    quantityUpsell.addEventListener('click', (event) => {
      const quantity = event?.target?.dataset?.quantity;
      const quantityEl = document.querySelector('[action*="cart/add"] [name="quantity"]');

      if (quantity && quantityEl) {
        quantityEl.value = quantity;
        quantityEl.dispatchEvent(new Event('input'));
      }

      const atc = document.querySelector('#teeAtcButton, [action*="cart/add"] [type="submit"]');

      if (atc) {
        atc.scrollIntoView({ behavior: 'smooth', block: 'end' });
        setTimeout(() => {
          atc.click();
        }, 200);
      }
    });
  });
});

document.addEventListener('teeinblue-event-component-injected', function() {
  if(Shopify.country === 'DE')  {
    const target = document.querySelector("#teeFormActions");
    const locale = (Shopify.locale || '').toLowerCase();

    const paypalText = locale.indexOf('en') === 0
      ? 'Pay safely after 30 days with PayPal'
      : 'Sicher bezahlen nach 30 Tagen mit PayPal';

    const klarnaText = locale.indexOf('en') === 0
      ? 'Pay by invoice with Klarna'
      : 'Kauf auf Rechnung mit Klarna';

    if (target) {
      target.insertAdjacentHTML("afterend", `
        <style>
        .teeinblue-enabled #teeFormInputs {
            margin-bottom: 0;
        }
        .teeinblue-enabled #teeFormActions {
            margin: 0;
            background-color: var(--tee-form-bg-color);
        }
        .custom-info {
            list-style: none;
            padding-left: 0;
            display: flex;
            flex-direction: column;
            gap: 5px;
            margin-top: 0;
            background-color: var(--tee-form-bg-color);
            padding-top: 5px;
            padding-bottom: 15px;
            border-radius: 0 0 10px 10px;
        }
        .custom-info img {
            width: 20px;
        }
        .custom-info .klarna img {
            width: 30px;
        }
        .custom-info li .icon-and-text {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
        }
        .custom-info li span span {
            font-size: 14px;
            line-height: 1;
            color: #000;
        }
        </style>

        <ul class="custom-info">
          <li class="paypal">
            <span class="icon-and-text">
              <img class="icon" src="https://cdn.shopify.com/s/files/1/0796/8119/2273/files/pngimg.com_-_paypal_PNG7.png?v=1725633087" width="50">
              <span>${paypalText}</span>
            </span>
          </li>
          <li class="klarna">
            <span class="icon-and-text">
              <img class="icon" src="https://cdn.shopify.com/s/files/1/0796/8119/2273/files/Marketing_Badge_With_Clear_Space.png?v=1725633089" width="70">
              <span>${klarnaText}</span>
            </span>
          </li>
        </ul>
      `);
    }
  } else {
    const target = document.querySelector("#teeFormActions");
    if(target) {
      target.insertAdjacentHTML("afterend", `
        <style>
          .teeinblue-enabled #teeFormInputs {
              margin-bottom: 0;
          }
          .teeinblue-enabled #teeFormActions {
            margin: 0;
            background-color: var(--tee-form-bg-color);
            padding-bottom: 20px;
            border-radius: 0 0 10px 10px;
          }
        </style>
      `)
    }
  }

  const elementToMove = document.querySelector('product-info .product-form__quantity'); 
  const insertAfterElement = document.querySelector('product-info product-form .product-form__buttons .product-form__submit');
  if (elementToMove && insertAfterElement) {        
      insertAfterElement.insertAdjacentElement('beforebegin', elementToMove);
  }
});
